import { AccountSelect, TreeNode } from "../backend/backendapi";

export class Entry {
    readonly node: TreeNode;
    readonly accounts: AccountSelect;
    readonly wideAcccounts: number[];
    readonly isRoot: boolean = true;
    constructor(node: TreeNode, accounts: AccountSelect, wideAcccounts: number[], isRoot: boolean = true) {
        this.node = node;
        this.accounts = accounts;
        this.wideAcccounts = wideAcccounts;
        this.isRoot = isRoot;
    }

    get id(): number {
        return this.node.dbId!;
    }

    get name(): string {
        return this.node.text!;
    }

    get title(): string {
        return this.node.text!;
    }

    get children(): Entry[] {
        return this.node.nodes?.map(e => new Entry(e, this.accounts, this.wideAcccounts, false)) ?? [];
    }

    get selected(): boolean {
        return this.node?.dbId === this.accounts?.selectedItem;
    }

    get state(): { expanded: boolean } {
        return { expanded: this.wideAcccounts.includes(this.id) };
    }
}
